<template>
  <!-- 主账号信息管理页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

      <config-title-hang>
        <span slot="config_title_hang_ele2">主账号{{ account }}</span>
      </config-title-hang>

      <config-hang @click.native="changePasswordBtnHandle">
        <img
          slot="config_hang_ele1"
          src="~assets/img/register/mima_hei.png"
          alt
        />
        <span slot="config_hang_ele2">修改密码</span>
        <img
          slot="config_hang_ele4"
          src="~assets/img/config/youjiantou.png"
          alt
        />
      </config-hang>

      <config-hang @click.native="changephoneNumberBtnHandle">
        <img
          slot="config_hang_ele1"
          src="~assets/img/register/shouji_hei.png"
          alt
        />
        <span slot="config_hang_ele2">换绑手机号</span>
        <img
          slot="config_hang_ele4"
          src="~assets/img/config/youjiantou.png"
          alt
        />
      </config-hang>

      <div class="public_config_que_ren_btn" @click="configReturnBtnHandle">
        退出登录
      </div>
    </div>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
export default {
  data() {
    return {
      account: sessionStorage.getItem('account') //获取用户账户信息
    }
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    changePasswordBtnHandle() {
      ////修改密码按钮
      this.$router.push('ChangePassWord')
    },
    changephoneNumberBtnHandle() {
      ///换绑手机号按钮
      this.$router.push('ChangePhoneNumber')
    },
    configReturnBtnHandle() {
      ////退出登录按钮
      sessionStorage.clear() //清空浏览器缓存token
      this.$store.dispatch('asyUpdataToken', '') ///清空vuex里面的token
      this.$router.replace('/login')
    }
  },

  mounted() {
    console.log('mounted阶段')
  },
  created() {
    console.log('created阶段')
    /// 获取子账号列表接口，获取数据
    // this.$request({
    //   method: "post",
    //   url: "/user/findSubAccountList",
    //   data: {
    //     token: this.$store.state.token
    //   }
    // })
    //   .then(res => {
    //     if (res.data.code != 0) {
    //       this.$showTipsToast(3, res.data.message);
    //       ////说明信息填写错误,控制失败了，
    //       return;
    //     } else {
    //       ////、控制成功了
    //       this.ServeSonAccountData = res.data.data; ////拿到服务器返回的数据结果
    //       // this.$store.dispatch("asyUpdataServeSceneData", this.ServeSceneData); ///异步提交信息到仓库
    //       // this.$showTipsToast(1, "获取成功", true); ////提示框
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  }
}
</script>

<style>
.config_hight_change_account_number_manage {
  height: 40px;
  line-height: 40px;
}
</style>
